<template>
  <div class="wrapper">
    <half-circle-spinner />
  </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners';
export default {
  name: 'Loader',
  components: {
    HalfCircleSpinner,
  },
};
</script>

<style scoped>
.wrapper {
  display: flex;
  flex: 1 1;
  justify-content: center;
  align-items: center;
}
</style>
